import * as React from 'react'





// 11:30  =>   0px
// dann pixel pro minute


// const minZeit = '10:00'
// const maxZeit = '3:00'







export default function ContentView({tag,bands}) {






const pixelPerMinute = 3.0

const calcMinuten = zeit => {
    let stunden = parseInt(zeit.split(':')[0])
    let minuten = parseInt(zeit.split(':')[1])
    if(stunden < 5) {
        stunden += 24
    }
    return (stunden*60)+minuten
}

const calcPosition = zeit => {
    return (calcMinuten(zeit) - calcMinuten(minZeit)) * pixelPerMinute
}



const calcMinMaxZeit = (tag,bands) => {

    let split = 8

    let maxStd = 0
    let minStd = 23

    for(let band of bands) {


        if(band.tag === tag) {
            
            let vonStd = parseInt(band.von.substring(0,band.von.indexOf(':')))
            let vonMin = parseInt(band.von.substring(band.von.indexOf(':')+1))

            if(vonStd > split && vonStd < minStd) {
                minStd = vonStd
            }

            let bisStd = parseInt(band.bis.substring(0,band.bis.indexOf(':')))
            let bisMin = parseInt(band.bis.substring(band.bis.indexOf(':')+1))

            if(bisMin > 0) {
                if(bisStd === 23) {
                    bisStd = 0
                } else {
                    bisStd++
                }
            }

            if(bisStd < split && bisStd > maxStd) {
                maxStd = bisStd
            }
        }

    }

    return [minStd+":00",maxStd+":00"]
}





    // const minMaxZeit = calcMinMaxZeit(tag,bands)

    const minZeit = calcMinMaxZeit(tag,bands)[0]
    const maxZeit = calcMinMaxZeit(tag,bands)[1]

    const height = calcPosition(maxZeit)

    

    const renderBands = (tag,stage) => {
        let ret = []
        for(let band of bands) {
            if(band.tag === tag && band.stage === stage) {
                ret.push(
                    <div
                        className="band"
                        style={{
                            top: calcPosition(band.von),
                            height: (calcPosition(band.bis)-calcPosition(band.von))
                        }}
                    >
                        <span style={{position: 'absolute', left: '12px', top: '12px'}}>
                            {band.link != null ? 
                                <a target='_blank' href={band.link}>{band.label}</a>
                            :
                                band.label
                            }
                        </span>
                        <span style={{position: 'absolute', right: '12px', top: '12px'}}>
                            {band.von} - {band.bis}
                        </span>
                        <span style={{position: 'absolute', left: '12px', bottom: '12px'}}>
                            {band.genre}
                        </span>
                        <span style={{position: 'absolute', right: '12px', bottom: '12px'}}>
                            {band.bewertung}
                        </span>
                    </div>
                )
            }

        }
        return ret
    }




    const renderTime = () => {
        let ret = []

        let minStunde = minZeit.substring(0,2)
        let maxStunde = maxZeit.substring(0,1)

        console.log(maxStunde)

        for(let std = minStunde; std < 24; std++) {
            ret.push(
                <div
                    className="zeitlinie"
                    style={{
                        top: calcPosition(std + ":00") + 142,
                    }}
                >
                    {std} Uhr
                </div>
            )
        }

        for(let std = 0; std <= maxStunde; std++) {
            ret.push(
                <div
                    className="zeitlinie"
                    style={{
                        top: calcPosition(std + ":00") + 142,
                    }}
                >
                    {std} Uhr
                </div>
            )
        }

        return ret
    }









    return (

        <div className="content-view">

            {renderTime()}

            {/* <div className="stage time">
                <div className="label"></div>
                <div className="content" style={{height: height}}>{renderTime()}</div>
            </div> */}

            <div className="spacer" style={{width: "60px"}}>
            </div>

            <div className="stage">
                <div className="label">MAIN STAGE</div>
                <div className="content" style={{height: height}}>{renderBands(tag,'MAIN STAGE')}</div>
            </div>

            <div className="stage">
                <div className="label">T-STAGE</div>
                <div className="content" style={{height: height}}>{renderBands(tag,'T-STAGE')}</div>
            </div>

            <div className="stage">
                <div className="label">CAMEL STAGE</div>
                <div className="content" style={{height: height}}>{renderBands(tag,'CAMEL STAGE')}</div>
            </div>

            <div className="stage">
                <div className="label">CAMPSITE CIRCUS</div>
                <div className="content" style={{height: height}}>{renderBands(tag,'CAMPSITE CIRCUS')}</div>
            </div>
        </div>



    )


    
}


















